import { createReducer } from 'redux/shelf';
import { search } from 'redux/shelf/api';

export const actions = {
  fetch: search.post`search`(),
};

export const reducer = createReducer(actions, {
  [actions.fetch]: (state, { payload }) => {
    const products = payload.entity.items.reverse();
    const isNextPage = payload.entity.meta.offset > 0;
    const updateTotalCount = !payload.entity.meta.q;
    return {
      ...state,
      fetch: isNextPage ? [...products, ...state.fetch] : products,
      count: payload.entity.meta.total,
      totalCount: updateTotalCount
        ? payload.entity.meta.total
        : state.totalCount,
    };
  },
});
